const parseFilterDataMappings = {
  created_on: ['created_on:gte', 'created_on:lte'],
  'load_weight_min': 'load_weight:gte',
  'load_weight_max': 'load_weight:lte',
  'load_volume_min': 'load_volume:gte',
  'load_volume_max': 'load_volume:lte',
  'shipped_customer_id': 'shipped_customer.id:in',
  'vendor_id': 'vendor.id:in',
  'origin_address_id': 'origin_address.id:in',
  'destination_address_id': 'destination_address.id:in',
}

export default parseFilterDataMappings